<template>
  <div class="main-content">
    <div class="center-body">
      <Nav />

      <!-- 第一层 -->
      <!-- <div class="row" style="position: relative; text-align: center; padding: 40px 0; background: #f8faff;">
  <div style="max-width: 1800px; margin: 0 auto;">

    <div style="margin-top: 40px; width: 100%;">

      <img src="../../assets/img/zlindex3.png" style="width: 100%; border-radius: 8px;" />
    </div>
  </div>
</div> -->

      <!-- <div class="row" style="position: relative; text-align: center; padding: 0; background: #f8faff; margin: 0; width: 100%;">
  <div style="max-width: 100%; width: 100%; margin: 0;">
    <div style="margin-top: 0; width: 100%;">
      <img 
        src="../../assets/img/zlindex3.png" 
        style="
          width: 100%; 
          height: auto; 
          border-radius: 0; /* 若需要圆角可保留8px，这里取消圆角避免边缘空白 */
          display: block; /* 消除图片底部默认空白 */
          object-fit: cover; /* 确保图片填满容器（若图片比例和容器不一致，会裁剪边缘） */
        " 
      />
    </div>
  </div>
</div> -->


      <div class="banner">
        <div style="max-width: 1200px; margin: 0 auto;">
          <div
            style="color: #000; font-size: 54px; font-weight: 400; margin-bottom: 25px;text-align: center;padding-top: 40px;">
            智慧科技引领产业革新
          </div>
          <div style="font-size: 18px; color: #666; margin-bottom: 50px;text-align: center;">
            贸宝信息科技为行业提供前沿解决方案，融合人工智能与大数据技术，主力企业数字化转型升级
          </div>
        </div>

        <div style="text-align: center;margin-top: 70px;">

           <button style="padding: 16px 44px; background: #000; color: #fff; border: none; border-radius: 8px; cursor: pointer;margin-right: 80px;">了解更多</button>
            <button style="padding: 16px 44px; background: #000; color: #fff; border: none; border-radius: 8px; cursor: pointer;margin-left: 80px;">联系我们</button>
        </div>
      </div>



      <!-- 第二层（替换后的解决方案板块） -->
      <div style="margin: 120px auto; min-height: 60px; width: 1200px;">
        <!-- 标题区域 -->
        <div class="row ju-c al-c" style="color: #666; font-size: 16px;">
          创新解决方案
        </div>
        <div
          style="color: #000; font-size: 44px; font-weight: 400; margin-bottom: 25px;text-align: center;padding-top: 40px;">
          我们为您提供最佳解决方案
        </div>
        <div class="row ju-c al-c" style="margin-top: 20px;">
          <div class="item-no" style="width: 120px; height: 2px; background-color: #0febe7;"></div>
        </div>

        <!-- 解决方案卡片区域 -->
        <div class="row ju-c" style="padding: 80px 0;margin-top: 40px; border-radius: 8px;background: #f4f5ff;">
          <!-- 智慧燃气解决方案 -->
          <div class="col-no al-c" style="width: 33%;">
            <div
              style="width: 50px; height: 50px; border-radius: 50%; background: #e8f3ff; display: flex; justify-content: center; align-items: center;">
              <img src="../../assets/img/cpzxIcon1.png" style="height: 40px;" />
            </div>
            <div style="font-size: 18px; font-weight: 600; color: #333; margin-top: 35px;text-align: left; ">智慧燃气解决方案
            </div>
            <div style="font-size: 14px; color: #666; line-height: 20px; margin-top: 8px; text-align: left;">
              实时监测，智能调度安全预警一体化平台<br>
              提升能源利用效率
              <br>
            </div>
          </div>

          <!-- 智慧水务解决方案 -->
          <div class="col-no al-c" style="width: 33%;">
            <div
              style="width: 50px; height: 50px; border-radius: 50%; background: #e8fff3; display: flex; justify-content: center; align-items: center;">
              <img src="../../assets/img/cpzxIcon2.png" style="height: 40px;" />
            </div>
            <div style="font-size: 18px; font-weight: 600; color: #333; margin-top: 35px;text-align: left;">智慧水务解决方案
            </div>
            <div style="font-size: 14px; color: #666; line-height: 20px; margin-top: 8px; text-align: left;">
              水资源智能管控平台，实现
              水质监控<br>管网优化与智能计量
            </div>
          </div>

          <!-- 智能工厂解决方案 -->
          <div class="col-no al-c" style="width: 33%;">
            <div
              style="width: 50px; height: 50px; border-radius: 50%; background: #f3e8ff; display: flex; justify-content: center; align-items: center;">
              <img src="../../assets/img/cpzxIcon3.png" style="height: 40px;" />
            </div>
            <div style="font-size: 18px; font-weight: 600; color: #333; margin-top: 35px;text-align: left;">智能工厂解决方案
            </div>
            <div style="font-size: 14px; color: #666; line-height: 20px; margin-top: 8px; text-align: left;">
              AI赋能的生产优化系统
              <br>提升制造效率与质
              量控制水平
            </div>
          </div>
        </div>
      </div>
      <div class="development">
        <div class="development-inner">
          <div class="development-left">
            <p class="development-tag">研发中心</p>
            <h2 class="development-title">数字技术发展推动行业变革</h2>
            <p class="development-desc">
              研发是贸宝科技创新驱动的核心，企业响应国家政策，研发自主知识产权核心技术，加强与上下游企业合作，构建技术创新生态链。
            </p>
          </div>
          <div class="development-right">
            <div class="development-item">
              <div class="development-icon-wrap" aria-hidden="true">
                <svg class="development-shield-svg" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="32" cy="32" r="30" fill="#e8ecff" />
                  <path
                    d="M32 10 L48 18 V32 C48 42 40 50 32 54 C24 50 16 42 16 32 V18 Z"
                    fill="#3949ab"
                  />
                  <path d="M36 22 L26 34 H33 L30 44 L40 32 H33 Z" fill="#fff" />
                </svg>
              </div>
              <div class="development-item-text">
                <div class="development-item-title">物联网平台</div>
                <p class="development-item-desc">
                  适应多网络多协议，具备海量连接、高性能、高可用、高稳定、高安全、开放性等优势。
                </p>
              </div>
            </div>
            <div class="development-item">
              <div class="development-icon-wrap" aria-hidden="true">
                <svg class="development-shield-svg" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="32" cy="32" r="30" fill="#e8ecff" />
                  <path
                    d="M32 10 L48 18 V32 C48 42 40 50 32 54 C24 50 16 42 16 32 V18 Z"
                    fill="#3949ab"
                  />
                  <path d="M36 22 L26 34 H33 L30 44 L40 32 H33 Z" fill="#fff" />
                </svg>
              </div>
              <div class="development-item-text">
                <div class="development-item-title">SaaS云计算技术</div>
                <p class="development-item-desc">
                  软件即服务，即开即用满足中小企业降本增效需求。涵盖行业各业务领域数字化应用。
                </p>
              </div>
            </div>
            <div class="development-item">
              <div class="development-icon-wrap" aria-hidden="true">
                <svg class="development-shield-svg" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="32" cy="32" r="30" fill="#e8ecff" />
                  <path
                    d="M32 10 L48 18 V32 C48 42 40 50 32 54 C24 50 16 42 16 32 V18 Z"
                    fill="#3949ab"
                  />
                  <path d="M36 22 L26 34 H33 L30 44 L40 32 H33 Z" fill="#fff" />
                </svg>
              </div>
              <div class="development-item-text">
                <div class="development-item-title">大数据与AI技术</div>
                <p class="development-item-desc">
                  为行业提供各业务领域的数据资源化资产化能力，提升企业精准管理、智能决策水平。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三层（标题左对齐的数字化转型板块） -->
      <div class="hxyx-box"
        style="height: auto; padding: 160px 0; background: url('data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iMSIgeDE9IjAiIHgyPSIxIiB5MT0iMCIgeTI9IjAiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMC45OTgsIDAuMDAxMDAwMDAwMDAwMDAwMDAwOSwgLTAuMDAwMTUxMjM0NTY3OTAxMjM0NywgMC45OTgsIC0wLjAwMiwgMC41MDEpIj48c3RvcCBzdG9wLWNvbG9yPSIjZTZmOGYxIiBzdG9wLW9wYWNpdHk9IjEiIG9mZnNldD0iMCI+PC9zdG9wPjxzdG9wIHN0b3AtY29sb3I9IiNkY2U5ZjciIHN0b3Atb3BhY2l0eT0iMSIgb2Zmc2V0PSIwLjYiPjwvc3RvcD48c3RvcCBzdG9wLWNvbG9yPSIjZWVmMmZiIiBzdG9wLW9wYWNpdHk9IjEiIG9mZnNldD0iMSI+PC9zdG9wPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjMSkiPjwvcmVjdD48L3N2Zz4=');">
        <div
          style="width: 1200px; margin: 0 auto; display: flex; align-items: flex-start; justify-content: space-between;">
          <!-- 文字区域（标题左对齐） -->
          <div style="width: 70%;">
            <div style="color: #333; font-size: 36px; font-weight: 400; line-height: 1.4; text-align: left;">
              我们助力客户实现数字化转型
            </div>

            <div style="margin-top: 30px; color: #666; font-size: 16px; line-height: 28px; text-align: left;">
              <!-- 全流程效率提升（左对齐） -->
              <p style="display: flex; align-items: flex-start; margin-bottom: 20px;">
                <span
                  style="color: #333; margin-right: 8px; margin-top: 4px;display: inline-block;width: 8px;height: 4px;background: #0288d1;border-radius: 2px; margin-top: 10px;"></span>
                <span>
                  <span style="font-weight: 400; color: #333; font-size: 18px; display: block;">全流程效率提升</span>
                  <span
                    style="margin-top: 4px; display: block;margin-top: 12px;font-size: 12px;">通过端到端的流程管理，消除部门壁垒，让数据驱动决策，显著提升运营效率。</span>
                </span>
              </p>
              <!-- 全项目成本优化（左对齐） -->
              <p style="display: flex; align-items: flex-start; margin-bottom: 20px;">
                <span
                  style="color: #333; margin-right: 8px; margin-top: 4px;display: inline-block;width: 8px;height: 4px;background: #0288d1;border-radius: 2px;margin-top: 10px;"></span>
                <span>
                  <span style="font-weight: 400; color: #333; font-size: 18px; display: block;">全项目成本优化</span>
                  <span
                    style="margin-top: 4px; display: block;margin-top: 12px;font-size: 12px;">以项目为主线，实现成本的精准预测、过程控制和复盘分析，最大化投资回报。</span>
                </span>
              </p>
              <!-- 全产业链协同（左对齐） -->
              <p style="display: flex; align-items: flex-start;">
                <span
                  style="color: #333; margin-right: 8px; margin-top: 4px;display: inline-block;width: 8px;height: 4px;background: #0288d1;border-radius: 2px;margin-top: 10px;"></span>
                <span>
                  <span style="font-weight: 400; color: #333; font-size: 18px; display: block;">全产业链协同</span>
                  <span
                    style="margin-top: 4px; display: block; margin-top: 12px;font-size: 12px;">打破信息孤岛，连接上下游数据，构建透明、敏捷、高效的协同生态。</span>
                </span>
              </p>
            </div>

            <div style="text-align:left;">
              <!-- 产品介绍按钮（左对齐） -->
              <button
                style="margin-top: 40px; padding: 10px 32px; background: #000; color: #fff; border: none; border-radius: 4px; font-size: 14px; font-weight: 400; cursor: pointer;">
                产品介绍
              </button>
            </div>
          </div>

          <!-- 图片区域（保持原型排版） -->
          <div style="width: 100%; display: flex; flex-direction: column; gap: 15px; align-items: flex-end;">
            <!-- <img src="../../assets/img/gywmBanner.png" style="width: 220px; border-radius: 6px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);" /> -->
            <img src="../../assets/img/zlindex41.png"
              style="height: 430px; " />
            <!-- <img src="../../assets/img/gywmBanner.png" style="width: 220px; border-radius: 6px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);" /> -->
          </div>
        </div>
      </div>

      <!-- 第四层（替换后的成功案例板块） -->

      <div class="mfty-box" style="background-color: #f0f0f0; height: auto; padding: 100px 0 120px;">
        <!-- 标题区域（匹配原型的标题下划线样式） -->
        <div
          style="color: #000; font-size: 44px; font-weight: 400; margin-bottom: 25px;text-align: center;padding-top: 40px;">
          成功案例
          <div
            style="width: 60px; height: 3px; background-color: #0fbee7; position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%);">
          </div>
        </div>

        <div style="margin-top: 40px; width: 100%; display: flex; justify-content: center; padding: 0 20px;">
          <!-- banner2 - 缩小尺寸并优化显示效果 -->
          <img src="../../assets/img/zlindex1.png" style="
      max-width: 1200px;  /* 限制最大宽度，适配大屏 */
      height: auto;  /* 保持宽高比 */
      border-radius: 8px;
      object-fit: cover;  /* 防止图片拉伸变形 */
      image-rendering: -webkit-optimize-contrast;  /* 优化图片显示清晰度 */
    " />
        </div>
        <!-- 案例Logo区域（2行4列布局，统一间距） -->
        <!-- <div style="width: 1200px; margin: 0 auto; margin-top: 50px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 30px;"> -->
        <!-- 天伦集团（选中状态） -->
        <!-- <div style="padding: 20px; background: #fff; border: 2px solid #409eff; border-radius: 8px; text-align: center;">
      <img src="../../assets/img/gywmBanner.png" style="width: 80px; margin-bottom: 10px;" />
      <div style="font-size: 16px; font-weight: 500; color: #333;">天伦集团</div>
      <div style="font-size: 14px; color: #999;">TIANLUN GROUP</div>
    </div> -->

        <!-- 滨海投资 -->
        <!-- <div style="padding: 20px; background: #fff; border: 1px solid #eee; border-radius: 8px; text-align: center;">
      <img src="../../assets/img/zlindex1.png" style="width: 80px; margin-bottom: 10px;" />
      <div style="font-size: 16px; font-weight: 500; color: #333;">滨海投资</div>
      <div style="font-size: 14px; color: #999;">BINHAI INVESTMENT</div>
    </div> -->

        <!-- 长春燃气 -->
        <!-- <div style="padding: 20px; background: #fff; border: 1px solid #eee; border-radius: 8px; text-align: center;">
      <img src="../../assets/img/gywmBanner.png" style="width: 80px; margin-bottom: 10px;" />
      <div style="font-size: 16px; font-weight: 500; color: #333;">长春燃气</div>
      <div style="font-size: 14px; color: #999;">CC GAS</div>
    </div> -->

        <!-- 深圳燃气（统一布局） -->
        <!-- <div style="padding: 20px; background: #fff; border: 1px solid #eee; border-radius: 8px; text-align: center;">
      <img src="../../assets/img/gywmBanner.png" style="width: 80px; margin-bottom: 10px;" />
      <div style="font-size: 16px; font-weight: 500; color: #333;">深圳燃气</div>
        <div style="font-size: 14px; color: #999;">BINHAI INVESTMENT</div>
    </div> -->

        <!-- 新疆城建股份 -->
        <!-- <div style="padding: 20px; background: #fff; border: 1px solid #eee; border-radius: 8px; text-align: center;">
      <img src="../../assets/img/gywmBanner.png" style="width: 80px; margin-bottom: 10px;" />
      <div style="font-size: 16px; font-weight: 500; color: #333;">新疆城建股份</div>
        <div style="font-size: 14px; color: #999;">BINHAI INVESTMENT</div>
    </div> -->

        <!-- 煤氣1 -->
        <!-- <div style="padding: 20px; background: #fff; border: 1px solid #eee; border-radius: 8px; text-align: center;">
      <img src="../../assets/img/gywmBanner.png" style="width: 80px; margin-bottom: 10px;" />
      <div style="font-size: 16px; font-weight: 500; color: #333;">燃气</div>
      <div style="font-size: 14px; color: #999;">Gas</div>
    </div> -->

        <!-- 煤氣2 -->
        <!-- <div style="padding: 20px; background: #fff; border: 1px solid #eee; border-radius: 8px; text-align: center;">
      <img src="../../assets/img/gywmBanner.png" style="width: 80px; margin-bottom: 10px;" />
      <div style="font-size: 16px; font-weight: 500; color: #333;">燃气</div>
      <div style="font-size: 14px; color: #999;">Gas</div>
    </div> -->

        <!-- 煤氣3 -->
        <!-- <div style="padding: 20px; background: #fff; border: 1px solid #eee; border-radius: 8px; text-align: center;">
      <img src="../../assets/img/gywmBanner.png" style="width: 80px; margin-bottom: 10px;" />
      <div style="font-size: 16px; font-weight: 500; color: #333;">燃气</div>
      <div style="font-size: 14px; color: #999;">Gas</div>
    </div> -->


      </div>
    </div>


    <!-- 第五层（技术服务板块） -->
    <div class="row" style="position: relative; text-align: center; padding: 80px 0; background: #fff;">
      <div style="max-width: 1200px; margin: 0 auto;">
        <!-- 标题区域 -->
        <div
          style="color: #000; font-size: 44px; font-weight: 400; margin-bottom: 25px;text-align: center;padding-top: 40px;">
          技术服务</div>
        <div style="font-size: 14px; color: #666; margin-bottom: 50px;">全方位保障体系助力客户成功</div>

        <!-- 服务卡片区域 -->
        <div style="display: flex; justify-content: center; gap: 40px;">
          <!-- 顾问咨询服务 -->
          <div style="width: 360px; padding: 30px; background: #f8faff; border-radius: 8px; text-align: left;">
            <div style="display: flex; align-items: center; margin-bottom: 15px;">
              <div
                style="width: 32px; height: 32px; background: #e1e8ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px;">
                <!-- 可替换为实际图标 -->
                <span style="color: #409eff;">💡</span>
              </div>
              <div style="font-size: 18px; font-weight: 600; color: #333;">顾问咨询服务</div>
            </div>
            <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 15px;">
              专业的顾问专家团队，为企业客户量身定制数字化转型的顶层规划方案
            </div>
            <div style="font-size: 14px; color: #409eff; cursor: pointer;">联系我们 ></div>
          </div>

          <!-- 技术文档中心 -->
          <div style="width: 360px; padding: 30px; background: #f8faff; border-radius: 8px; text-align: left;">
            <div style="display: flex; align-items: center; margin-bottom: 15px;">
              <div
                style="width: 32px; height: 32px; background: #e1e8ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px;">
                <!-- 可替换为实际图标 -->
                <span style="color: #409eff;">📄</span>
              </div>
              <div style="font-size: 18px; font-weight: 600; color: #333;">技术文档中心</div>
            </div>
            <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 15px;">
              完善的产品文档和使用指南，包含白皮书和操作手册随时查阅
            </div>
            <div style="font-size: 14px; color: #409eff; cursor: pointer;">查看文档 ></div>
          </div>

          <!-- 技术支持服务 -->
          <div style="width: 360px; padding: 30px; background: #f8faff; border-radius: 8px; text-align: left;">
            <div style="display: flex; align-items: center; margin-bottom: 15px;">
              <div
                style="width: 32px; height: 32px; background: #e1e8ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px;">
                <!-- 可替换为实际图标 -->
                <span style="color: #409eff;">📞</span>
              </div>
              <div style="font-size: 18px; font-weight: 600; color: #333;">技术支持服务</div>
            </div>
            <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 15px;">
              专业工程师团队提供7×24小时技术支持服务，快速响应并解决问题
            </div>
            <div style="font-size: 14px; color: #409eff; cursor: pointer;">联系支持团队 ></div>
          </div>
        </div>
      </div>
    </div>


    <!-- 第六层（关于我们数据统计板块） -->
    <div class="row gywm">
      <div style="max-width: 1200px; margin: 0 auto;">
        <!-- 标题区域 -->
        <div
          style="color: #000; font-size: 44px; font-weight: 400; margin-bottom: 25px;text-align: center;padding-top: 40px;">
          关于我们</div>
        <div style="font-size: 14px; color: #666; margin-bottom: 50px;">专注智慧科技解决方案，助力企业数字化转型</div>

        <!-- 数据卡片区域 -->
        <div style="display: flex; justify-content: center; gap: 40px; margin-bottom: 30px;">
          <!-- 公司成立年份 -->
          <div
            style="width: 320px; padding: 45px 0; background: #f8fdff94; border: 1px solid #b3e5fc; border-radius: 8px; text-align: center;">
            <div style="font-size: 36px; font-weight: bold; color: #333; margin-bottom: 8px;">2016</div>
            <div style="font-size: 14px; color: #666;">公司成立年份</div>
          </div>

          <!-- 行业解决方案 -->
          <div
            style="width: 320px; padding: 45px 0;background: #f8fdff94; border: 1px solid #b3e5fc; border-radius: 8px; text-align: center;">
            <div style="font-size: 36px; font-weight: bold; color: #0288d1; margin-bottom: 8px;">50+</div>
            <div style="font-size: 14px; color: #0288d1;">行业解决方案</div>
          </div>

          <!-- 企业客户 -->
          <div
            style="width: 320px; padding: 45px 0; background: #f8fdff94; border: 1px solid #b3e5fc; border-radius: 8px; text-align: center;">
            <div style="font-size: 36px; font-weight: bold; color: #0288d1; margin-bottom: 8px;">600+</div>
            <div style="font-size: 14px; color: #0288d1;">企业客户</div>
          </div>
        </div>

        <!-- 了解更多按钮 -->
        <button
          style="padding: 10px 24px; background: #000; color: #fff; border: none; border-radius: 4px; cursor: pointer;">了解更多</button>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Nav from "./nav.vue";
import Foot from "./foot.vue";

export default {
  name: "App",
  components: {
    Nav,
    Foot
  },
  data() {
    return {
      curHeight: 0,
      index: 0
    };
  },
  watch: {
    windowHeight(val) {
      let that = this;
      console.log("实时屏幕高度：", val, that.windowHeight);
    },
  },
  beforeMount() {

    var h = document.documentElement.clientHeight || document.body.clientHeight;

    this.curHeight = h; //减去页面上固定高度height

  },
  methods: {
    enter(e) {
      this.index = e
    },
    leave() {
      this.index = 0
    }
  },
  mounted() {
    var that = this;
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        that.curHeight = window.fullHeight; // 高

      })()
    };
  },
};
</script>
<style scoped>
.main-content {
  min-height: 100%;
  min-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: block;
  position: absolute;
  /* background: #f7f7f7; */
}

.prduct-box {
  width: 1200px;
  /* padding-top: 60px; */
  padding-bottom: 100px;
  margin: 0 auto;
}

.center-body {
  margin: 0 auto;
}

.fixed-bottom {
  position: fixed;
  bottom: 0;
}

.hxyx-box {
  height: 793px;
  background-image: url(../../assets/img/gywmbg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 80px;
  text-align: center;
}

.mfty-box {
  height: 600px;
  background-color: #fff;
  padding-top: 60px;
  text-align: center;
}

.active {
  color: #fff !important;
  background-color: #0070FD !important;
}

.gywm {
  position: relative;
  text-align: center;
  padding: 120px 0;
  background: linear-gradient(to bottom, #f8faff, #ffffff);
  background: url(./../../assets/img/gywm1.png);
}

.banner {
  background: url(./../../assets/img/khalBanner.png) no-repeat;
  background-size: cover;
  background-position: top center;
  height: 1000px;
  padding: 180px 0;
}

.development {
  background: #fff;
  padding: 100px 0 120px;
}

.development-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 72px;
}

.development-left {
  flex: 1;
  max-width: 520px;
  text-align: left;
}

.development-tag {
  margin: 0 0 16px;
  font-size: 15px;
  font-weight: 500;
  color: #5c6bc0;
  letter-spacing: 0.02em;
}

.development-title {
  margin: 0 0 22px;
  font-size: 32px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.35;
}

.development-desc {
  margin: 0;
  font-size: 15px;
  line-height: 1.85;
  color: #6b7280;
}

.development-right {
  flex: 1;
  min-width: 0;
  max-width: 560px;
}

.development-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 40px;
}

.development-item:last-child {
  margin-bottom: 0;
}

.development-icon-wrap {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(160deg, #eef0ff 0%, #e0e5ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(92, 107, 192, 0.12);
}

.development-shield-svg {
  width: 40px;
  height: 40px;
  display: block;
}

.development-item-text {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.development-item-title {
  font-size: 17px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 10px;
  line-height: 1.4;
}

.development-item-desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.75;
  color: #6b7280;
}

@media (max-width: 1024px) {
  .development-inner {
    flex-direction: column;
    gap: 48px;
  }

  .development-left,
  .development-right {
    max-width: 100%;
  }
}
</style>
